/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeveloperApp } from './DeveloperApp';
import {
    DeveloperAppFromJSON,
    DeveloperAppFromJSONTyped,
    DeveloperAppToJSON,
} from './DeveloperApp';

/**
 * 
 * @export
 * @interface DeveloperAppsResponse
 */
export interface DeveloperAppsResponse {
    /**
     * 
     * @type {Array<DeveloperApp>}
     * @memberof DeveloperAppsResponse
     */
    data?: Array<DeveloperApp>;
}

/**
 * Check if a given object implements the DeveloperAppsResponse interface.
 */
export function instanceOfDeveloperAppsResponse(value: object): value is DeveloperAppsResponse {
    let isInstance = true;

    return isInstance;
}

export function DeveloperAppsResponseFromJSON(json: any): DeveloperAppsResponse {
    return DeveloperAppsResponseFromJSONTyped(json, false);
}

export function DeveloperAppsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeveloperAppsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(DeveloperAppFromJSON)),
    };
}

export function DeveloperAppsResponseToJSON(value?: DeveloperAppsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(DeveloperAppToJSON)),
    };
}

